import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CategoriaModel } from 'src/app/core/model/categoria.model';
import { CategoriaService } from 'src/app/core/service/categoria.service';
import { EnvconfigService } from 'src/app/core/service/envconfig.service';
import { EncryptDecryptService } from 'src/app/core/service/EncryptDecryptService.service';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'],
})
export class InicioComponent {
  public frm: FormGroup;
  selectedProduct: any;
  public categorias: CategoriaModel[];
  searchKey = new FormControl('');

  constructor(
    private categoriaService: CategoriaService,
    private environment: EnvconfigService,
    private encryptService: EncryptDecryptService,
  ) {
    this.categorias = this.categoriaService.getCategoriaSistema();
    this.frm = new FormGroup({
      searchKey: new FormControl(''),
    });
  }

  // sso.component.ts

  onSelectedProduct(data: any) {
    // 1. Recuperamos la cadena de configuración (ej: "SPB;FIDMOD;GARCARTERA")
    const configSistemas = this.environment.get('SistemasAlternativos');

    // 2. Separamos por ';' limpiando espacios vacíos
    const sistemasAlternativos = configSistemas
      ? configSistemas.split(';').map((s) => s.trim())
      : [];

    const codigo = data?.sistema?.codigoSistema;

    // 3. Validación dinámica contra la variable del JSON
    if (sistemasAlternativos.includes(codigo)) {
      this.onSelectedProductAlternative(data);
      return;
    }
 
    let _url = '';
    this.selectedProduct = data;
    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      _url = this.construirURLDebug(data);
    } else {
      _url = this.construirURL(data);
    }
    window.open(_url, '_blank');
  }
  
  //contruye las urls dinámicamente según venga del API SUC
  construirURL(data: any): string {
    const _codigoUsuario = sessionStorage.getItem(
      this.environment.get('USERCODE'),
    )!;
    const _codigoSistema = data.sistema.codigoSistema;
    const _idSistema = data.sistema.idSistema;
    const s_token = sessionStorage.getItem(this.environment.get('TOKEN_NAME'))!;
    let _token = this.encryptService.decrypt(
      s_token,
      this.environment.get('keyCaptcha'),
    );

    if (data.sistema.url.endsWith('#')) {
      return `${data.sistema.url}/home/inicio`;
    } else {
      if (Boolean(data.sistema.flg_sso_encriptado)) {
        let codigoUsuario =
          this.encryptService.encryptUsingAES256(_codigoUsuario);
        let codigoSistema =
          this.encryptService.encryptUsingAES256(_codigoSistema);
        let idSistema = this.encryptService.encryptUsingAES256(_idSistema);
        return `${data.sistema.url}/home/inicio?u=${codigoUsuario}&s=${codigoSistema}&i=${idSistema}&t=${_token}`;
      } else {
        return `${data.sistema.url}/home/inicio?t=${_token}&u=${_codigoUsuario}&s=${_codigoSistema}&i=${_idSistema}`;
      }
    }
  }

  construirURLDebug(data: any): string {
    const _codigoUsuario = sessionStorage.getItem(
      this.environment.get('USERCODE'),
    )!;
    const _codigoSistema = data.sistema.codigoSistema;
    const _idSistema = data.sistema.idSistema;
    const s_token = sessionStorage.getItem(this.environment.get('TOKEN_NAME'))!;
    let _token = this.encryptService.decrypt(
      s_token,
      this.environment.get('keyCaptcha'),
    );
    let urlBase = 'http://localhost:4201';

    let codigoUsuario = this.encryptService.encryptUsingAES256(_codigoUsuario);
    let codigoSistema = this.encryptService.encryptUsingAES256(_codigoSistema);
    let idSistema = this.encryptService.encryptUsingAES256(_idSistema);

    return `${urlBase}/home/inicio?t=${_token}&u=${codigoUsuario}&s=${codigoSistema}&i=${idSistema}`;
  }
  busquedaCategoriaSistema() {
    this.categorias = this.categoriaService.getCategoriaSistemaPorNombre(
      this.frm.value['searchKey'],
    );
  }

  onSelectedProductAlternative(data: any) {
    // 1. Definimos la URL de destino correctamente manejando el scope
    let urlDestino: string;

    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      urlDestino = 'http://localhost:4201/sso-receptor';
    } else {
      // Aseguramos que no haya doble slash si la URL ya trae uno

      urlDestino = `${data.sistema.url}/sso-receptor`;
    }

    // 2. Abrimos la ventana
    const nuevaVentana = window.open(urlDestino, '_blank');

    if (nuevaVentana) {
      const s_token = sessionStorage.getItem(
        this.environment.get('TOKEN_NAME'),
      )!;
      const _token = this.encryptService.decrypt(
        s_token,
        this.environment.get('keyCaptcha'),
      );
      console.log('token desencriptado', _token);

      const handshakeListener = (event: MessageEvent) => {
        // IMPORTANTE: Validar que el mensaje viene de la ventana que abrimos
        if (event.data.tipo === 'SISTEMA_RECEPTOR_LISTO') {
          // 3. Enviamos el paquete de datos

          const targetOrigin = urlDestino.replace('/sso-receptor', '');

          // 🔒 Ciframos los datos sensibles de contextualización en memoria segura
          const usuarioEncriptado = this.encryptService.encryptUsingAES256(
            sessionStorage.getItem(this.environment.get('USERCODE')) ?? '',
          );
          const idSistemaEncriptado = this.encryptService.encryptUsingAES256(
            data.sistema.idSistema ?? '',
          );
          const codigoSistemaEncriptado =
            this.encryptService.encryptUsingAES256(
              data.sistema.codigoSistema ?? '',
            );

          // 3. Despachamos el paquete de datos encriptado al canal privado del navegador
          nuevaVentana.postMessage(
            {
              tipo: 'SSO_PAYLOAD_DATA',
              t: _token,
              u: usuarioEncriptado,
              i: idSistemaEncriptado,
              s: codigoSistemaEncriptado,
            },
            targetOrigin,
          );

          // 4. Limpiamos el listener
          window.removeEventListener('message', handshakeListener);
        }
      };

      window.addEventListener('message', handshakeListener);
    }
  }
}
